import { apiGet, apiPatch } from '@/lib/http/client';

import type {
  ActiveCampaignFieldMapping,
  ActiveCampaignFieldMappingsResponse,
  AhoyPropertyType,
} from '../types';

export type UpdateAcMappingBody =
  | Partial<{
      ahoy_property: string | null;
      sync_direction: string;
      conflict_resolution: string | null;
    }>
  | {
      action: 'create_property';
      suggested_name: string;
      field_type: AhoyPropertyType;
    };

export async function getActiveCampaignFieldMappings(
  orgId: number | string
): Promise<ActiveCampaignFieldMappingsResponse> {
  return apiGet<ActiveCampaignFieldMappingsResponse>(
    `/api/orgs/${orgId}/activecampaign/field-mappings/`
  );
}

export async function updateActiveCampaignFieldMapping(
  orgId: number | string,
  mappingId: number,
  body: UpdateAcMappingBody
): Promise<ActiveCampaignFieldMapping> {
  return apiPatch<ActiveCampaignFieldMapping>(
    `/api/orgs/${orgId}/activecampaign/field-mappings/${mappingId}/`,
    body
  );
}
